import httpManager from "@/app/shared/utils/httpManager";

/**
 * Obtiene la lista de alias registrados para "Enviar como" de un canal de correo.
 *
 * @param {number} channelCustomerId - ID del identificador de canal.
 * @returns {Promise<Array>} Lista de alias registrados.
 */
export default async function (channelCustomerId) {
  const response = await httpManager.get(`/channels/channel-customer/${channelCustomerId}/send-as-aliases/`);
  return response?.data;
}
